<template>
  <div id="app">
    <div class="main-wrap">
      <app-header></app-header>
      <div class="content-wrap container">
        <router-view></router-view>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'app',
  components: {
    AppFooter,
    AppHeader
  }
};
</script>

<style>
body {
  font-family: 'ArialMT', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ededed;
  color:  #36444B;
  font-size: 16px;
  line-height: 18px;
}

.main-wrap {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  width: 1000px;
  margin: 0 auto;
}

.content-wrap {
  padding-top: 30px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
</style>
